module.exports = __webpack_public_path__ + "img/36.974e0bee.jpeg";